import type { User } from 'firebase/auth';

/**
 * Protected admin APIs require the custom claim set by verifyTotpCode. Keep
 * this check in one place so background contexts do not probe those APIs while
 * Firebase Auth has a signed-in, but not yet 2FA-verified, user.
 */
export async function hasVerifiedTotp(user: User | null): Promise<boolean> {
    if (!user) return false;

    try {
        const tokenResult = await user.getIdTokenResult();
        return tokenResult.claims.totpVerified === true;
    } catch {
        // A token refresh/auth transition is still in progress. Callers use
        // their public or empty projection until the next auth notification.
        return false;
    }
}
